<!-- page starts-->
    <section class="page-wrapper">
      <div class="cart-top-section">
      	 <div class="container">
      	 	<div class="cart-top-detail">
      	 		<div class="red-titel">Assign Attendees</div>
      	 	</div>
      	 </div>
      </div>
      <div class="checkout-center-section cf">
      	 <div class="container">
      	 	<div class="checkout-center-detail cf">
      	 		<div class="checkout-center-detail-left">
      	 			<div class="cart-center-detail-top cf">
      	 				<div class="cart-center-top cf">
      	 					<div class="cart-center-top-left">
      	 						<div class="cart-center-top-left-image">
      	 							<img src="assets/images/Bitmap.png">
      	 						</div>
      	 						<div class="cart-center-top-left-vs">
      	 							<div class="cart-center-top-left-vs-inner">
	      	 							<h3>VS</h3>
	      	 						</div>
      	 						</div>
      	 						<div class="cart-center-top-left-right-image">
      	 							<img src="assets/images/Bitmap-two.png">
      	 						</div>
      	 					</div>
      	 					<div class="cart-center-top-center">
      	 						<p>Ashton United V South Shields</p>
      	 						<h3>Saturday, 3 November 2020 15:00</h3>
      	 					</div>
      	 				</div>
      	 				<div class="cart-center-bottom cf">
      	 					<div class="cart-center-bottom-general">
      	 						<h3>General Admission </h3>
		      	 				<div class="checkout-center-detail-right-general-admission-detail cf">
		      	 					<div class="checkout-center-detail-right-general-admission-name">
		      	 						<h3>Senior (Over 65) #112</h3>
		      	 						<p>Assigned to: John Smith <br><a href="">johnsmith@gmail.com </a>| ASH0000843</p>
		      	 						
		      	 					</div>
		      	 					<div class="checkout-center-detail-right-general-admission-price">
		      	 						<p>£20.00</p>
		      	 						
		      	 					</div>
		      	 					<div class="checkout-center-detail-right-away-fans-btn">
		      	 						<p><a href="#login-box" class="popup-login">Edit Details</a></p>
		      	 					</div>
		      	 				</div>
      	 					</div>
      	 					<div class="cart-center-bottom-away">
      	 						<h3>Away Fans </h3>
		      	 				<div class="checkout-center-detail-right-general-admission-detail cf">
		      	 					<div class="checkout-center-detail-right-general-admission-name">
		      	 						<h3>Senior (Over 65) #112</h3>
		      	 						<p>Assigned to: John Smith <br><a href="">johnsmith@gmail.com </a>| ASH0000843</p>
		      	 						<h3>Senior (Over 65) #112</h3>
		      	 						<p>Assigned to: John Smith <br><a href="">johnsmith@gmail.com </a>| ASH0000843</p>
		      	 					</div>
		      	 					<div class="checkout-center-detail-right-general-admission-price">
		      	 						<p>£20.00</p>
		      	 						<p>£20.00</p>
		      	 					</div>
		      	 					<div class="checkout-center-detail-right-away-fans-btn">
		      	 						<p><a href="#login-box" class="popup-login">Edit Details</a></p>
		      	 						<p><a href="#login-box" class="popup-login">Edit Details</a></p>    	 						
		      	 					</div>
		      	 				</div>
      	 					</div>
      	 				</div>
      	 			</div>
      	 			<div class="cart-center-detail-top cf">
      	 				<div class="cart-center-top cf">
      	 					<div class="cart-center-top-left">
      	 						<div class="cart-center-top-left-image">
      	 							<img src="assets/images/Bitmap.png">
      	 						</div>
      	 						<div class="cart-center-top-left-vs">
      	 							<div class="cart-center-top-left-vs-inner">
	      	 							<h3>VS</h3>
	      	 						</div>
      	 						</div>
      	 						<div class="cart-center-top-left-right-image">
      	 							<img src="assets/images/Bitmap-two.png">
      	 						</div>
      	 					</div>
      	 					<div class="cart-center-top-center">
      	 						<p>Ashton United V South Shields</p>
      	 						<h3>Saturday, 3 November 2020 15:00</h3>
      	 					</div>
      	 				</div>
      	 				<div class="cart-center-bottom cf">
      	 					<div class="cart-center-bottom-general">
      	 						<h3>General Admission </h3>
		      	 				<div class="checkout-center-detail-right-general-admission-detail cf">
		      	 					<div class="checkout-center-detail-right-general-admission-name">
		      	 						<h3>Senior (Over 65) #112</h3>
		      	 						<p>Assigned to: John Smith <br><a href="">johnsmith@gmail.com </a>| ASH0000843</p>
		      	 						
		      	 					</div>
		      	 					<div class="checkout-center-detail-right-general-admission-price">
		      	 						<p>£20.00</p>
		      	 						
		      	 					</div>
		      	 					<div class="checkout-center-detail-right-away-fans-btn">
		      	 						<p><a href="#login-box" class="popup-login">Edit Details</a></p>
		      	 						
		      	 					</div>
		      	 				</div>
      	 					</div>
      	 					
      	 				</div>
      	 			</div>
      	 		</div>
      	 		<div class="checkout-center-detail-right">
      	 			<div class="checkout-center-detail-right-general-admission">
      	 				<p>The price of tickets and the fees applied may change after you login and any of your account benefits are applied. Fees for non-UK delivery may not be shown here, but  you will have a chance to view them at the checkout summary before confirming your order.</p>
      	 				<div class="checkout-center-detail-payment">
      	 					<div class="checkout-center-detail-payment-total">
      	 						<div class="checkout-payment-total">
      	 							<div class="checkout-payment-total-text">Total</div>
      	 							<div class="checkout-payment-total-price">£20.00</div>
      	 						</div>
      	 						<div class="checkout-payment-discount">
      	 							<div class="checkout-payment-total-text">Per item fees</div>
      	 							<div class="checkout-payment-total-price">£20.00</div>
      	 						</div>
      	 					</div>
      	 					<div class="checkout-payment-payable">
      	 						<div class="checkout-payment-payable-text">Payable Amount</div>
      	 						<div class="checkout-payment-payable-price">£20.00</div>
      	 					</div>
      	 					<div class="checkout-payment-payable-btn">
      	 						<a href="#">Checkout</a>
      	 					</div>
      	 				</div>
      	 			</div>
      	 		</div>
      	 	</div>
      	 	<div class="want-to-buy-season-tickets-section cf">
      	 		<div class="want-to-buy-season-tickets-left">
      	 			<h3>Want to buy Season Tickets?</h3>
      	 		</div>
      	 		<div class="want-to-buy-season-tickets-right">
      	 			<div class="want-to-buy-season-tickets-right-image">
      	 				<img src="assets/images/season-ic.png">
      	 			</div>
      	 		</div>
      	 	</div>
      	 </div>
      </div>
    </section><!-- page ends-->
    <div class="login-section forlogin-section assign mfp-hide" id="login-box">
      <div class="add-popup cf">
            <div class="container">
               <div class="checkout-center-detail-popup">  
                  <h2>Add Details</h2>
                  <p>Assign to an existing account by entering an account number and the supporter’s name.</p>
                  <p>Alternatively, assign tickets to a new account by entering the name of the person attending.</p>
                  <form>
                        <div class="checkout-center-detail-address-box cf"> 
                                <div class="checkout-address-box full">
                                  <input type="text" name="" placeholder="company" class="input-style"> 
                                </div>
                                <div class="checkout-address-box full">
                                  <input type="text" name="" placeholder="Address1" class="input-style"> 
                                </div>
                                <div class="checkout-address-box full">
                                  <input type="text" name="" placeholder="Address2" class="input-style"> 
                                </div>
                                <div class="checkout-address-box full">
                                  <input type="text" name="" placeholder="City" class="input-style"> 
                                </div>
                                <div class="checkout-address-box full">
                                  <input type="text" name="" placeholder="Phone" class="input-style"> 
                                </div>
                                <div class="checkout-address-box-btn">
                                    <a href="#">Assign</a>
                                </div>
                        </div>
                  </form>
               </div>
            </div>
      </div>
    </div>